import { AuditLogMessageAction } from '../../../state/types';

export const MESSAGE_ACTION_ICONS_MAPPER = {
  [AuditLogMessageAction.CREATED]: 'checked-message',
  [AuditLogMessageAction.EDITED]: 'pencil',
  [AuditLogMessageAction.DELETED]: 'trash-can',
  [AuditLogMessageAction.PENDING]: 'clock',
  [AuditLogMessageAction.APPROVED]: 'approval',
  [AuditLogMessageAction.BULK_APPROVED]: 'approval',
  [AuditLogMessageAction.REJECTED]: 'no-entry',
  [AuditLogMessageAction.BULK_REJECTED]: 'no-entry',
  [AuditLogMessageAction.ARCHIVED]: 'archived',
  [AuditLogMessageAction.BULK_ARCHIVED]: 'archived'
};

interface SystemUserData {
  user: string;
  description: string;
  svgName: string;
}

export const AUTOMATION_USERS = ['ai', 'system'];

export const automationUserMapper: Record<string, SystemUserData> = {
  ai: { user: 'Auto Moderation', description: 'AI assistance', svgName: 'ai-automation' },
  system: { user: 'Automation', description: 'Moderation Engine', svgName: 'automation' }
};
